import axios from 'axios';
import React, { useEffect, useState } from 'react'
import AdminMenu from '../../components/Layout/AdminMenu'
import Layout from '../../components/Layout/Layout'
import { useAuth } from '../../context/auth';
import moment from "moment"
import { server } from '../../App';
import {Select} from "antd"
const {Option} = Select

const AdminOrders = () => {

    const [status,setStatus] = useState(["Not Processed","Processing","Shipped","Delievered","Cancelled"]);
    const [changeStatus,setChangeStatus] = useState("");

    const [orders,setOrders] = useState([]);
    const [auth] = useAuth();

    //get all orders details
    const getOrders = async () => {
        try {
            const {data} = await axios.get(`${server}/api/v1/auth/all-orders`);
            setOrders(data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(()=>{
        if(auth?.token) getOrders();
    },[auth?.token]);

    //handle order status by admin
    const handleChange = async (orderId,value) => {
        try {
            const {data} = await axios.put(`${server}/api/v1/auth/order-status/${orderId}`,{status:value})
            getOrders();
        } catch (error) {
            console.log(error);
        }
    }

  return (
    <Layout title={"All Orders Data"}>
        <div className='row mt-3'>
            <div className='col-md-3'>
                <AdminMenu/>
            </div>
            <div className='col-md-9 overflow-scroll'>
                <h1 className='text-center'>All Orders</h1>
                {orders?.map((o, i) => {
                      return (
                      <div className="border shadow">
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Status</th>
                              <th scope="col">Buyer</th>
                              <th scope="col">Date</th>
                              <th scope="col">Payment</th>
                              <th scope="col">Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{i + 1}</td>
                              <td>
                                  <Select bordered={false} onChange={(value)=>handleChange(o._id,value)} defaultValue={o?.status}>
                                    {status.map((s,i)=>(
                                        <Option key={i} value={s}>{s}</Option>
                                    ))}
                                  </Select>
                              </td>
                              <td>{o?.buyer?.name}</td>
                              <td>{moment(o?.createdAt).fromNow()}</td>
                              <td>{o?.payment.success ? "Success" : "Failed"}</td>
                              <td>{o?.products?.length}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div className="container">
                          {o?.products?.map((p, i) => (
                            <div className="row mb-2 p-3 card flex-row" key={p._id}>
                            <div className="col-md-4">
                            <img
                              src={`${server}/api/v1/products/product-photo/${p._id}`}
                              className="card-img-top object-fit-contain"
                              alt={p.name}
                              width="100px"
                              height={"100px"}
                            />
                          </div>
                          <div className="col-md-8">
                            <p>{p.name}</p>
                            <p>{p.description.substring(0, 60)}</p>
                            <p>Price : ₹{p.price}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  );
                })}
            </div>
        </div>
    </Layout>
  )
}

export default AdminOrders